'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        console.error(error)
    }, [error])

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center space-y-6 p-8">
                <div className="mx-auto w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center">
                    <AlertTriangle className="w-8 h-8 text-destructive" />
                </div>
                <div>
                    <h2 className="text-2xl font-bold text-foreground mb-2">
                        Bir Hata Olustu
                    </h2>
                    <p className="text-muted-foreground">
                        Beklenmeyen bir hata meydana geldi. Lutfen tekrar deneyin.
                    </p>
                </div>
                <div className="flex gap-4 justify-center">
                    <Button onClick={() => reset()}>
                        Tekrar Dene
                    </Button>
                    <Button variant="outline" onClick={() => window.location.href = '/'}>
                        Ana Sayfaya Don
                    </Button>
                </div>
            </div>
        </div>
    )
}
